import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { LoginService } from '../service/login.service';

@Injectable({
  providedIn: 'root',
})
export class AfterLoginGuard {
  private router = inject(Router);
  private loginService = inject(LoginService);

  canActivate(): boolean | UrlTree {
    this.loginService.initUserToken();
    if (this.loginService.isLogin()) {
      this.router.navigate(['quote']);
    } else {
      return true;
    }
  }
}
